import {
  ArrowLeftRight,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableRow
} from '@chain-zen/ui'

interface BackhaulPostsSkeletonProps {
  postsView: 'card' | 'table'
}

export function BackhaulPostsSkeleton({ postsView }: BackhaulPostsSkeletonProps) {
  if (postsView === 'card') {
    return (
      <Card role="status" aria-label="post-cards-skeleton-mobile">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <ArrowLeftRight className="h-4 w-4 text-primary" />
            Backhauls
          </CardTitle>
        </CardHeader>
        <CardContent>
          {Array.from({ length: 4 }).map((_, index) => (
            <Card key={index} className="w-full">
              <CardHeader className="pb-2">
                {/* Load number and tags section */}
                <div className="flex justify-between items-center">
                  <Skeleton className="h-4 w-16" />
                  <div className="flex gap-2">
                    <Skeleton className="h-4 w-10" />
                    <Skeleton className="h-4 w-10" />
                  </div>
                </div>
              </CardHeader>
              <CardContent className="space-y-4">
                {/* Weight and pick/drop section */}
                <div className="flex justify-between items-center">
                  <Skeleton className="h-3 w-20" />
                  <Skeleton className="h-3 w-16" />
                </div>

                {/* Origin section */}
                <div className="flex items-center gap-2">
                  <Skeleton className="h-4 w-4 rounded-full" />
                  <Skeleton className="h-4 w-36" />
                </div>
                <div className="ml-6">
                  <Skeleton className="h-3 w-40" />
                </div>

                {/* Destination section */}
                <div className="flex items-center gap-2">
                  <Skeleton className="h-4 w-4 rounded-full" />
                  <Skeleton className="h-4 w-36" />
                </div>
                <div className="ml-6">
                  <Skeleton className="h-3 w-40" />
                </div>
              </CardContent>
            </Card>
          ))}
        </CardContent>
      </Card>
    )
  }

  return (
    <Card role="status" aria-label="backhaul-table-skeleton">
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <ArrowLeftRight className="h-4 w-4 text-primary" />
          Backhauls
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableBody>
            {Array.from({ length: 2 }).map((_, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Skeleton className="h-4 w-16" />
                </TableCell>
                <TableCell>
                  <div className="flex flex-col gap-2">
                    <Skeleton className="h-4 w-20" />
                    <Skeleton className="h-3 w-20" />
                  </div>
                </TableCell>
                <TableCell>
                  <div className="flex flex-col gap-2">
                    <Skeleton className="h-4 w-20" />
                    <Skeleton className="h-3 w-20" />
                  </div>
                </TableCell>
                <TableCell>
                  <Skeleton className="h-4 w-16" />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <div className="flex justify-center mt-4">
          <Skeleton className="h-5 w-40" />
        </div>
      </CardContent>
    </Card>
  )
}
